const styles = (theme) => ({
  card: {
    minHeight: "260px",
    padding: "16px 16px 12px",
    display: "flex",
    flexDirection: "column",
    gap: 10,
    boxShadow: "none",
    border: `1px solid ${
      theme.palette.type === "dark" ? "#353232" : "#e0e0e0"
    }`,
    borderRadius: 10,
    transition: "box-shadow 0.2s ease, border-color 0.2s ease",
    "&:hover": {
      boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
      borderColor: theme.palette.type === "dark" ? "#555" : "#bdbdbd",
    },
  },
  cardHeader: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    padding: 0,
    "& >div": {
      alignSelf: "unset",
      marginTop: 0,
      marginRight: 0,
    },
    "& .MuiCardHeader-content": {
      flex: 1,
      minWidth: 0,
      overflow: "hidden",
    },
  },
  cardTitleWrap: {
    display: "flex",
    flexDirection: "column",
    gap: 2,
    minWidth: 0,
  },
  cardTitle: {
    fontSize: 15,
    color: theme.palette.type === "dark" ? "#e0e0e0" : "#2C2C34",
    fontWeight: 600,
    whiteSpace: "normal",
    wordBreak: "break-word",
    margin: 0,
  },
  cardDescription: {
    fontSize: 12,
    color: theme.palette.type === "dark" ? "#9e9e9e" : "#8E8E8E",
    fontWeight: 400,
    margin: 0,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  cardActions: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    flexShrink: 0,
    paddingLeft: 8,
    "& button": {
      background: "none",
      padding: 0,
      cursor: "pointer",
    },
    "& svg": {
      fill: "transparent",
    },
  },
  cardContent: {
    flex: 1,
    padding: "10px 12px",
    borderRadius: 8,
    backgroundColor: theme.palette.type === "dark" ? "#1e1e1e" : "#F7F7F8",
    border: `1px solid ${theme.palette.type === "dark" ? "#2e2e2e" : "#eeeeee"}`,
    "& ul": {
      display: "flex",
      flexDirection: "column",
      gap: 6,
      listStyle: "none",
      margin: 0,
      padding: 0,
      "& li": {
        display: "flex",
        alignItems: "baseline",
        justifyContent: "space-between",
        gap: 8,
        fontSize: 13,
        "& p": {
          margin: 0,
          color: theme.palette.type === "dark" ? "#9e9e9e" : "#8E8E8E",
          fontWeight: 500,
          flexShrink: 0,
        },
        "& span": {
          color: theme.palette.type === "dark" ? "#e0e0e0" : "#33383F",
          fontWeight: 600,
          textAlign: "right",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          maxWidth: "55%",
        },
      },
    },
  },
});

export default styles;
